document.addEventListener('DOMContentLoaded', () => {
	const dialog = document.querySelector('#ad-image-dialog');

	if (!dialog) {
		return;
	}

	const openButtons = [...document.querySelectorAll('[data-ad-image-open]')];
	const imageSources = [...document.querySelectorAll('[data-ad-image-src]')];
	const closeButton = dialog.querySelector('[data-ad-image-close]');
	const prevButton = dialog.querySelector('[data-ad-image-prev]');
	const nextButton = dialog.querySelector('[data-ad-image-next]');
	const currentImage = dialog.querySelector('[data-ad-image-current]');
	const count = dialog.querySelector('[data-ad-image-count]');
	const images = imageSources.map((button) => ({
		src: button.dataset.adImageSrc,
		alt: button.dataset.adImageAlt || '',
	}));
	let currentIndex = 0;

	const setImage = (index) => {
		if (!currentImage || images.length === 0) {
			return;
		}

		currentIndex = (index + images.length) % images.length;
		currentImage.src = images[currentIndex].src;
		currentImage.alt = images[currentIndex].alt;

		if (count) {
			count.textContent = `${currentIndex + 1} / ${images.length}`;
		}
	};

	const openDialog = (index) => {
		setImage(index);

		if (typeof dialog.showModal === 'function') {
			dialog.showModal();
		}
	};

	openButtons.forEach((button) => {
		button.addEventListener('click', () => {
			openDialog(Number(button.dataset.adImageIndex || 0));
		});
	});

	closeButton?.addEventListener('click', () => {
		dialog.close();
	});

	prevButton?.addEventListener('click', () => {
		setImage(currentIndex - 1);
	});

	nextButton?.addEventListener('click', () => {
		setImage(currentIndex + 1);
	});

	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) {
			dialog.close();
		}
	});

	dialog.addEventListener('keydown', (event) => {
		if (event.key === 'ArrowLeft') {
			event.preventDefault();
			setImage(currentIndex - 1);
		}

		if (event.key === 'ArrowRight') {
			event.preventDefault();
			setImage(currentIndex + 1);
		}
	});
});
